/* @flow */
import React from 'react';
import cx from 'classnames';

import './styles/Receipt.scss';

const Receipt = React.createClass({
  render() {
    return (
      <table className={cx('Receipt', this.props.className)}>
        {this.props.children}
      </table>
    );
  },
});

export default Receipt;



// WEBPACK FOOTER //
// ./src/payments/components/Receipt.jsx